// extracted by css-extract-rspack-plugin
export default {"root":"styles_root__lCwVG","body2":"styles_body2__CD-Wp","seperator":"styles_seperator__bf4wv"};